<template>
    <div class="card tyre featured-top-spot border-0 mb-3">
        <div class="card-body rounded border text-start" :class="[tyreBorderColor + '-border']">
            <div class="row">
                <div class="col-12 col-md-6 col-lg-3 text-center text-md-start">
                    <div class="tyre-image">
                        <a :href="tyre.featured_content.image_link">
                            <img :src="this.baseUrl + tyre.featured_content.image" class="img-fluid" :alt="tyre.brand + ' ' + tyre.tyre_range + ' logo'" height="135" @error="replaceByDefault"/>
                        </a>
                    </div>
                </div>
                <div class="col-12 col-md-6 col-lg-5 my-3 my-md-0">
                    <div class="d-flex align-items-center mb-2">
                        <img :src="tyre.brand_image ? tyre.brand_image_url : tyre.brand_image_url + 'generic.png'" class="brand-image" :alt="tyre.brand + ' logo'" height="40"/>
                        <b class="d-inline ms-3">{{ tyre.tyre_range  }}</b>
                    </div>
                    <p class="mb-0" v-html="tyre.featured_content.text"></p>
                    <template v-if="tyre.tyre_video">
                      <checkatyre-tyre-video
                          custom-style="etyres"
                          :multi-video="true"
                          .tyre-video-details="tyre.tyre_video"
                          :identifier="`${tyre.brand_slug}-${tyre.range_slug}`"
                      ></checkatyre-tyre-video>
                    </template>
                </div>
                <div class="col-6 col-lg-2">
                    <b>{{ tyre.brand }}</b>
                    <p class="mb-0">{{ tyre.tyre_range  }}</p>
                    <p class="mb-0">{{ tyre.description }}</p>
                    <specialisms :tyre="tyre"></specialisms>
                    <rating-labels :fuel="tyre.fuel" :wet="tyre.wet" :decibels="tyre.decibels" :noise-rating="tyre.noise_rating"></rating-labels>
                    <div class="d-flex align-items-center">
                        <new-awards v-if="tyre.award_badges" :awards="tyre.award_badges" :tyre-url="tyre.tyre_info_url"></new-awards>
                        <fitments v-if="tyre.fitments?.length > 0" class="position-relative ms-2 mt-2" style="height: 30px;" :fitments="tyre.fitments"></fitments>
                    </div>
                    <div class="mt-2">
                        <reviews
                            :identifier="`${tyre.brand_slug}-${tyre.range_slug}`"
                        ></reviews>
                    </div>
                </div>
                <div class="col-6 col-lg-2">
                    <b class="price">&pound;{{ tyre.display_price }}</b>
                    <p class="mb-0 per">Per tyre</p>
                    <select name="quantity" id="quantity" class="form-control my-2" v-model="quantity">
                        <option v-for="index in 5" :key="index" :value="index">{{ index }}</option>
                    </select>
                    <button class="btn btn-primary w-100" :class="buttonColour" @click="trackAndAdd()">
                        {{ tyreText }}
                    </button>
                    <earliest-fitting
                        v-if="this.$parent.$parent.updatedPostcode && this.$parent.$parent.homeDelivery == false"
                        :fitting-today="tyre.fitting_today"
                        :fitting-tomorrow="tyre.fitting_tomorrow"
                        :earliest-fitting-date="tyre.earliest_fitting_date"
                        :postcode="postcode"
                    ></earliest-fitting>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import tyre from '@shared/mixins/tyre';

    export default {
        props: ['tyre', 'basket', 'postcode'],
        components: { },
        mixins: [tyre],
        data() {
            return {
                quantity: this.$parent.$parent.quantity,
                featuredTopSpotFlag: true
            }
        },
        mounted() {
        },
        methods: {
            trackAndAdd() {
                //Track Featured Top Spot Added To Basket
                if(typeof(this.$gtag) !== 'undefined') {
                    this.$gtag.event('FeaturedTopSpot', {
                        'event_category' : 'FeaturedTopSpot',
                        'event_label' : 'Added'
                    });
                }
                else {
                    console.log('gtag not loaded');
                }
                
                this.$parent.$parent.addTyreToBasket(this.tyre.st_code, this.quantity)
            }
        },
        computed: {
            tyreBorderColor() {
                let border = 'yellow';

                if(this.inBasket)
                {
                    border = 'blue';
                }

                return border;
            },
        }
    }
</script>

<style lang="scss" scoped>
    .featured-top-spot {
        .card-body {
            position: relative;
            .price {
                font-size: 22px;
            }
            .per {
                font-size: 12px;
            }
            .tyre-info-badge {
                position: absolute;
                bottom: 5px;
                left: -5px;
                text-align: left;
            }
            .tyre-image {
                a {
                    img {
                        max-height: 200px;
                        margin: 0 auto;
                        display: block;
                    }
                }
            }
        }
    }
</style>